/**
 * Vincent B666 (Eric 2026-08-05 SPEC STRICK PROD) — Coordination globale
 * pour pauser tous les pollers pendant qu'un upload chunké est en cours.
 *
 * Problème : pendant un upload (6 chunks × 10 Mo en parallèle), le pod
 * uvicorn était saturé. Les endpoints polling (/notifications, /version,
 * /agora/unread-count, /platform/pending-users, /agent/draft-queue) ne
 * pouvaient plus répondre et timeout-aient → Cloudflare 520 en cascade
 * sur TOUTES les requêtes de la page.
 *
 * Solution : le module UploadPage appelle `uploadState.start(id)` au début
 * et `.end(id)` à la fin. Les pollers vérifient `.isActive()` et se
 * skippent tant que c'est true. Une fois l'upload terminé, les pollers
 * reprennent au tick suivant (au max 30s de latence de badge, acceptable).
 *
 * Usage :
 *   import { uploadState } from "../lib/uploadState";
 *   uploadState.start("upload-abc");  // au démarrage
 *   uploadState.end("upload-abc");    // à la fin
 *   uploadState.isActive();           // depuis un poller → true/false
 */
const activeUploads = new Set();

export const uploadState = {
  start(id) {
    activeUploads.add(id);
    try {
      window.dispatchEvent(new CustomEvent("knoria:upload-active-change", {
        detail: { active: true, count: activeUploads.size },
      }));
    } catch { /* SSR safety */ }
  },
  end(id) {
    activeUploads.delete(id);
    try {
      window.dispatchEvent(new CustomEvent("knoria:upload-active-change", {
        detail: { active: activeUploads.size > 0, count: activeUploads.size },
      }));
    } catch { /* SSR safety */ }
  },
  isActive() {
    return activeUploads.size > 0;
  },
  count() {
    return activeUploads.size;
  },
};
